<template>
  <v-app-bar dark flat app height="80">
    <div
      class="d-flex flex-grow-1 justify-space-between align-center px-3 px-xl-0"
    >
      <v-toolbar-title>
        <BaseLink :to="homeLink">
          <img
            src="@/assets/images/logo-transparent.svg"
            width="192"
            height="48"
            alt="Paymentshield White Logo"
          />
        </BaseLink>
      </v-toolbar-title>

      <BaseButton
        :text="$vuetify.breakpoint.mdAndUp ? 'Why choose us?' : 'Why us?'"
        outlined
        rounded
        class="font-20"
        @click="openDrawer"
      />
    </div>
  </v-app-bar>
</template>

<script>
import { generateLinkHome } from "@/common/navigating";
import BaseLink from "@/components/BaseComponents/BaseLink";
import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters } from "vuex";
export default {
  name: "TenantsHeader",
  components: {
    BaseLink,
    BaseButton,
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["isSelfServe"]),
    homeLink() {
      return generateLinkHome(this.isSelfServe, this.$route);
    },
  },
  methods: {
    openDrawer() {
      this.$emit("openDrawer");
    },
  },
};
</script>
